module.exports = __webpack_public_path__ + "static/media/a69f87b3-ff48-44dc-9708-7e4e46de1b74.138d870c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/a69f87b3-ff48-44dc-9708-7e4e46de1b74.png
// module id = 1501
// module chunks = 0